import { DataModel } from "@toolpad/core/Crud";

import { IApiLogDto } from "../generated/api-client";
import { nameof } from "../utils/object.utils";
import MagicCrud, { MagicCrudFields } from "../components/MagicCrud";

type ApiLogDtoDataModel = IApiLogDto & DataModel;

export default function ApiLogsPages() {
  const columns: MagicCrudFields<IApiLogDto>[] = [
    {
      field: nameof<IApiLogDto>("id"),
      type: "number",
      extraType: "guid",
    },
    {
      field: nameof<IApiLogDto>("userIdentifier"),
      type: "string",
    },
    {
      field: nameof<IApiLogDto>("httpMethod"),
      type: "string",
    },
    {
      field: nameof<IApiLogDto>("path"),
      type: "string",
    },
    {
      field: nameof<IApiLogDto>("queryString"),
      type: "number",
      extraType: "guid",
    },
    {
      field: nameof<IApiLogDto>("payload"),
      type: "number",
      extraType: "guid",
    },
    {
      field: nameof<IApiLogDto>("statusCode"),
      type: "number",
      extraType: "guid",
    },
    {
      field: nameof<IApiLogDto>("durationMs"),
      type: "number",
      extraType: "guid",
    },
    {
      field: nameof<IApiLogDto>("ipAddress"),
      type: "number",
      extraType: "guid",
    },
    {
      field: nameof<IApiLogDto>("userAgent"),
      type: "number",
      extraType: "guid",
    },
    {
      field: nameof<IApiLogDto>("groupId"),
      type: "string",
      extraType: "guid",
    },
    {
      field: nameof<IApiLogDto>("timestamp"),
      type: "dateTime",
      editable: false,
    },
  ];

  return (
    <MagicCrud<ApiLogDtoDataModel>
      name="log"
      apiUrl="logs"
      columns={columns}
      appUrl="/logs"
    />
  );
}
